import { useEffect, useState } from "react";
import { gsap } from "gsap";


export function CampaignScreen() {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);



  useEffect(() => {


  const tl_repeat = gsap.timeline({ repeat: -1, yoyo:true});
  tl_repeat.to(".CSKV-1_G", { scale: 1.3, duration: 1, ease: "power1.inOut" });

  const tl_yoyo = gsap.timeline({ repeat: -1, yoyo:true});
  tl_yoyo.fromTo("#CSKV-5_G", { scale: 1.0 }, { scale: 1.1, duration: 1.5, ease: "power1.inOut" });
  ;





  const tl_yoyo2 = gsap.timeline({ repeat: -1, yoyo:true});
  tl_yoyo2.to("#CSKV-6-7_G ",{scale: 1.07, duration: 0.4, ease: "power1.inOut", delay:10})
  .to("#CSKV-6-7_G ",{scale: 1.0, duration: 0.3, ease: "power1.inOut"})
  ;

  const tl_logo = gsap.timeline({ repeat: 0});
  tl_logo
  .to("#CSmainComp, #CSKV, #CSmainCopy_G, #CSmainOptions_G", {opacity:1, duration: 0.1})
  .from("#CSmainLogo_G", {scale: "0", duration: 1.5, ease: "power1.inOut"})
  .from("#CSmainLogo", {x: "159px", duration: 1.5, ease: "power1.inOut"}, "-=1")
  .from("#CSlogo2", {x: "-100%", duration: 1.5, ease: "power1.inOut"}, "<")
  ;

  const tl_lockup = gsap.timeline({ repeat: 0});

  tl_lockup
  .from("#CSKV-1", {opacity:0, scale: 0, duration: 1.5, ease: "power1.inOut"})
  .from("#CSKV-1B", {opacity:0, scale: 0, duration: 1.5, ease: "power1.inOut"}, "-=1.3")
  .from("#CSKV-4", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)"}, "-=1.0")
  .from("#CSKV-3", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)"}, "-=1.3")
  .from("#CSKV-5, #CSKV-2", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)"}, "-=1.4")
  .from("#CSKV-6", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)"}, "-=1.4")
  .from("#CSKV-7", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)"}, "-=1.4")

  .from("#CScopy1, #CScopy1_cover", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.7)"}, "-=1.3")
  .from("#CScopy2, #CScopy2_cover", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.7)"}, "-=1.4")
  .from(".shine", {opacity: 0, duration: 0.1}, "-=0.5")
  .from(".CSintro_copy", {y: 30, opacity:0, duration: 1.5, ease: "elastic.out(1, 0.7)"}, "-=1.4")

  .from("#CSopt1", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)"}, "-=1.4")
  .from("#CSopt1_C", {y: 10, opacity:0, duration: 1.5, ease: "elastic.out(1, 0.7)"}, "-=1.4")
  .from("#CSopt2", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)"}, "-=1.5")
  .from("#CSopt2_C", {y: 10, opacity:0, duration: 1.5, ease: "elastic.out(1, 0.7)"}, "-=1.4")
  .from("#CSopt3", {scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)"}, "-=1.5")
  .from("#CSopt3_C", {y: 10, opacity:0, duration: 1.5, ease: "elastic.out(1, 0.7)"}, "-=1.4")
  .fromTo("#CSbtn1_G", {scale: 0, opacity:0}, {scale: 1, opacity:1, duration: 1.5, ease: "elastic.out(1, 0.7)"}, "-=1.4")
  ;






    const fetchLogoUrl = async () => {
      try {
        console.log('Fetching campaign logo URL from Supabase storage');
        const publicUrl = 'https://zzrxarrnwzexonyhdbiq.supabase.co/storage/v1/object/public/campaign-images/RVA_Refresh2025_HERO-ALpha_v02.png?t=2025-01-22T12%3A22%3A32.188Z';
        
        console.log('Retrieved public URL:', publicUrl);
        setLogoUrl(publicUrl);
      } catch (error) {
        console.error('Error fetching logo URL:', error);
      }
    };

    fetchLogoUrl();
  }, []);

  return (
    <div className="flex flex-col items-center" id="CSmainComp_G">


    <div id="CSmainComp" className="relative flex justify-center mt-24">
      <div id="CSmainLogo_G" className="relative flex justify-center">
        <div id="CSmainLogo" className="relative flex justify-center gap-4">
          <div className="flex-shrink-0">
            <img src="/imgs/logo1.png" alt="Live Your Best Lip!" className="w-[294px] h-auto" id="CSlogo1" />
          </div>
          <div className="flex-shrink-0 flex items-center overflow-hidden">
            <img src="/imgs/logo2.png" alt="Live Your Best Lip!" className="w-[412px] h-auto" id="CSlogo2" />
          </div>
        </div>
      </div>
    </div>
  
  
    <div className="relative mt-[0px]" id="CSKV" style={{height: '650px', width: '100%', display: 'flex', justifyContent: 'center'}}>
      <div className="absolute w-full max-w-[700px] h-auto CSKV-1_G" id="CSKV-1_G">
        <img src="/imgs/KV-1.png" alt="Live Your Best Lip!" className="w-full h-auto" id="CSKV-1" />
      </div>
      <div className="absolute w-full max-w-[700px] h-auto CSKV-1_G" id="CSKV-1_G2">
        <img src="/imgs/KV-1B.png" alt="Live Your Best Lip!" className="w-full h-auto" id="CSKV-1B" />
      </div>
      <div className="absolute w-full max-w-[700px] h-auto" id="CSKV-2_G">
        <img src="/imgs/KV-2.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="CSKV-2" />
      </div>
      <div className="absolute w-full max-w-[700px] h-auto floating">
        <img src="/imgs/KV-3.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="CSKV-3" />
      </div>
      <div className="absolute w-full max-w-[700px] h-auto floating2">
        <img src="/imgs/KV-4.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="CSKV-4" />
      </div>
      <div className="absolute w-full max-w-[700px] h-[610px]" id="CSKV-5_G" style={{transformOrigin:'50% 30%'}}>
        <img src="/imgs/KV-5.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="CSKV-5" />
      </div>
      <div className="absolute w-full max-w-[700px] h-[610px]" id="CSKV-6-7_G" style={{transformOrigin:'50% 30%'}}>
        <img src="/imgs/KV-6.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="CSKV-6" />
        <img src="/imgs/KV-7.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="CSKV-7" />
      </div>
    </div>
  
    <div id="CSmainCopy_G" className="relative flex flex-col w-auto h-auto items-center">
  {/* Copy1 and Copy1 Cover */}
  <div className="flex-shrink-0 relative  z-10">
    <img src="/imgs/copy1.png" alt="Live Your Best Lip!" className="w-[918px] h-auto" id="CScopy1" />
    <img
      src="/imgs/copy1_cover.png"
      alt="Live Your Best Lip!"
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[918px] h-[175px] z-10"
      id="CScopy1_cover"
    />
    {/* Shine Effect for Copy1 */}
    <div className="shine-container absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
      <div className="shine absolute top-0 left-0 w-[50%] h-full bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>
    </div>
  </div>

  {/* Copy2 and Copy2 Cover */}
  <div className="flex-shrink-0 -translate-y-[-1.25%] relative  z-20">
    <img src="/imgs/copy2.png" alt="Live Your Best Lip!" className="w-[1010px] h-auto" id="CScopy2" />
    <img
      src="/imgs/copy2_cover.png"
      alt="Live Your Best Lip!"
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[1010px] h-auto z-10"
      id="CScopy2_cover"
    />
    {/* Shine Effect for Copy2 */}
    <div className="shine-container absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
      <div className="shine absolute top-0 left-0 w-[50%] h-full bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>
    </div>
  </div>
</div>
  

  <div className="mx-auto mt-4 max-w-[100%]">
<p className="text-center text-3xl text-white font-Quicksand CSintro_copy">
Help shape the ultimate uni hacks to live your best student era! 🌟<br />Bonus stickers when you share a tip!
</p>
</div>
  
  
  
    <div id="CSmainOptions_G" className="relative flex flex-col w-auto h-auto items-center space-y-3 mt-[8%] mb-8">
      <div className="grid grid-cols-3 w-full gap-3">
        <div className="flex justify-center">
          <img src="/imgs/opt1.png" alt="Option 1" className="w-[186px] h-auto" id="CSopt1" />
        </div>
        <div className="flex justify-center">
          <img src="/imgs/opt2.png" alt="Option 2" className="w-[186px] h-auto" id="CSopt2" />
        </div>
        <div className="flex justify-center">
          <img src="/imgs/opt3.png" alt="Option 3" className="w-[186px] h-auto" id="CSopt3" />
        </div>
      </div>
    
  
  
      <div className="grid grid-cols-3 w-full gap-3">
        <div className="flex justify-center">
          <img src="/imgs/opt1_C.png" alt="Option 1 C" className="w-[321px] h-auto mt-8" id="CSopt1_C" />
        </div>
        <div className="flex justify-center">
          <img src="/imgs/opt2_C.png" alt="Option 2 C" className="w-[321px] h-auto mt-8" id="CSopt2_C" />
        </div>
        <div className="flex justify-center">
          <img src="/imgs/opt3_C.png" alt="Option 3 C" className="w-[321px] h-auto mt-8" id="CSopt3_C" />
        </div>
      </div>
    </div>

  </div>
  );
}